import { createFileRoute } from '@tanstack/react-router';
import { AdminPostCodePage } from '@/features/admin/admin-post-code-page';

export const Route = createFileRoute('/admin/post-code/')({
  component: AdminPostCodeIndexRoute,
});

function AdminPostCodeIndexRoute() {
  return <AdminPostCodePage />;
}
